'use strict';

exports.__esModule = true;
exports.default = undefined;

var _Modal = require('./Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-modal2/lib/index.js
// module id = 783
// module chunks = 0